<template>
    <div class="results-container">
      <p class="no-results" v-show='noResults'> <center> No search results!</center></p>
    <div v-for="payload in advancedSearchPayload">
      <div class="related">
        <div class="card">
          <div class="related-card-top row">
            <div class="col-sm-1">
              <input type="checkbox">
            </div>
            <div class="col-sm-11">
              <span class="name"> {{ payload['first_name'] }} {{ payload['last_name'] }} </span>
            </div>
          </div>


            <div :class="['related-card-bottom','row', 'middle', {removeBottomBorder:!hasRelationship(payload)}]">
              <div class="col-sm-2" v-for="(label, field) in customerTitleMap">
                <p class="label">{{ label }}</p>
                <p>{{ payload[field] }}</p>
              </div>
            </div>

          <div class="related-card-bottom row" v-if="hasRelationship(payload)">
            <div class="col-sm-2" v-show="hasPolicy(payload)">
              <p class="label">Policy</p>
              <p class="field">{{ getPolicyNumber(payload) }}</p>
            </div>
            <div class="col-sm-2">
              <p class="label">Quotations</p>
              <p class="field">{{ getQuotationNumber(payload) }}</p>
            </div>
            <div class="col-sm-2" v-show="hasrelatedCustomer(payload)">
              <p class="label">Co-Owner</p>
              <p class="field">{{ relatedCustomerName(payload) }}</p>
            </div>
            <div class="col-sm-2" v-show="hasDriver(payload)">
              <p class="label">Driver</p>
              <p class="field">{{ getDriverName(payload) }}</p>
            </div>
            <div class="col-sm-2" v-show="hasVehicle(payload)">
              <p class="label">Vehicle</p>
              <p class="field">{{ getVehicleDescription(payload) }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default{
    data(){
        return {
            customerTitleMap: {
            'status': 'Status',
            'trn': 'Govt ID',
            'date_of_birth': 'Date of Birth'
          },
          relationshipTitleMap: {
            'status': 'Status',
            'trn': 'Govt ID',
            'date_of_birth': 'Date of Birth',
          }
        };
    },
    computed: {
        ...mapState({
            advancedSearchPayload: state => state.advancedSearchPayload
        }),
        noResults: function(){
          if(this.advancedSearchPayload.length == 0)return true;
        }
    },
    methods: {
      hasVehicle: function(payload){
        if(payload.relationship !== undefined){
          if(payload.relationship.vehicle !==undefined ){
            if(payload.relationship.vehicle.length != 0)return true;
          }
        }
      },
      getVehicleDescription: function(payload){
          if(payload.relationship.vehicle !== undefined){
            if(payload.relationship.vehicle.length != 0){
              return payload.relationship.vehicle[0]['description'];
            }
          }
      },
      hasrelatedCustomer: function(payload){
        if(payload.relationship !== undefined){
          if(payload.relationship['co-owner'] !== undefined ){
            if(payload.relationship['co-owner'].length != 0) return true;
          }
          }
      },
      hasRelationship: function(payload){
        if(payload.relationship !== undefined) return true;
      },
      relatedCustomerName: function(payload){
        if(payload.relationship['co-owner'] !== undefined){
          if(payload.relationship['co-owner'].length !=0 ){
            var relatedCustomer = payload.relationship['co-owner'][0];
            return relatedCustomer['first_name'] + ' ' +  relatedCustomer['last_name'];
          }
        }
      },
      getQuotationNumber: function(payload){
        if(payload.quotations !== undefined){
          if(payload.quotations.length !== 0) return payload.quotations[0]['quotation_number'];
        }
      },
      hasPolicy: function(payload){
        if(payload.policies !== undefined){
          if(payload.policies.length !== 0) return true;
        }
      },
      getPolicyNumber: function(payload){
        if(payload.policies !== undefined){
          if(payload.policies.length !== 0) return payload.policies[0]['policy_number'];
        }
      },
      hasDriver: function(payload){
        if(payload.relationship.driver !== undefined){
          if(payload.relationship.driver.length != 0)return true;
        }
      },
      getDriverName: function(payload){
        if(payload.relationship.driver !== undefined){
          if(payload.relationship.driver.length != 0){
            var driver = payload.relationship.driver[0];
            return driver['first_name'] + ' ' + driver['last_name'];
          }
        }
      }
    }
};

</script>

<style scoped>
.results-container{
  margin-top:20px;
}
p.no-results{
  font-size: 21px;
  color: grey;
  padding-top: 40px;
}
p.label{
  color:gray;
  padding-bottom: 10px;
}
.field{
  color:#2c8ada;
  font-size: 15px;
}
.name{
  color:#2c8ada;
  font-size: 21px;
}
.related-card-bottom.middle{
  border-bottom: 1px solid lightgray;
  padding-bottom: 15px;
}
.customer-card-bottom, .related-card-bottom{
  padding-top: 20px;
}
.customer-card-top, .related-card-top{
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom:1px solid lightgray;
}
@media (min-width: 576px){
  .related-card-top .col-sm-1 {
      max-width: 1.333333%!important;
  }
}
.removeBottomBorder{
  border-bottom: none!important;
  padding-bottom: 0px!important;
}

</style>


// WEBPACK FOOTER //
// src/components/advancedSearchResult.vue